import { isNumber } from "../utils/utils";

/** @internal */
export function getPercentFilter() {

    return function(input) {

        if (!isNumber(input)) {
            return input;
        }

        return Math.round(input * 100);

    }

}
